/**
 * The working mark in React: the one spinner (the logo's zero, turning — D-71), the same element the html builders
 * write (./markSpinnerMarkup.ts), drawn by the one stylesheet (src/styles/markSpinnerCss.ts) and turned on the one
 * clock (src/utils/markSpinnerPhase.ts, which sees a React insertion like any other). Decorative: the words beside it
 * say what is happening, so it is hidden from assistive technology.
 */
import React from 'react';
import { markSpinnerClassName, type MarkSpinnerOptions } from './markSpinnerMarkup';

export type MarkSpinnerProps = MarkSpinnerOptions & {
  style?: React.CSSProperties;
  'data-testid'?: string;
};

export const MarkSpinner: React.FC<MarkSpinnerProps> = ({ size, tone, className, style, 'data-testid': testId }) => (
  <span className={markSpinnerClassName({ size, tone, className })} aria-hidden="true" style={style} data-testid={testId} />
);

export default MarkSpinner;
